/*
 * Forge Maestro
 * (c) Honeywell
 */

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { IconBase } from '../IconBase.js';
import { IconName } from '../IconName.enum.js';

const AlertIcon = forwardRef((props, ref) => {
    const { className = '', title, strokeWidth = 1.5 } = props;
    return (jsx(IconBase, Object.assign({ ref: ref, className: className, title: title, name: IconName.Alert }, { children: jsx("path", { strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", d: "M12 9.051v4m0 4h.01m-1.72-13.14-8.47 14.14a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3l-8.47-14.14a2 2 0 0 0-3.42 0Z" }) })));
});

export { AlertIcon };
//# sourceMappingURL=AlertIcon.js.map
